// Global message constants for the application
export const MESSAGES = {
  // Search related messages
  NO_RESULTS_FOUND: "No results found. Search Universities or Endowments",
  NO_ORGANIZATIONS_FOUND: "Organizations under investigation.",
  NO_VC_FIRMS_FOUND: "VC firms under investigation.",
  NO_ANGEL_FOUND: "Angel investors for this organization are under investigation",
  
  // Tooltips
  ENTITY_SEARCH_TOOLTIP: "Investigate people, firms, and organizations for ties to Israel, military backgrounds, and industry details",
  FINANCIAL_DATA_TOOLTIP: "Explore how institutions (e.g. universities and endowments) invest through private equity and venture capital.",
  
  // Navigation
  DISCLAIMER_TEXT: "Please read our disclaimer for important information about data verification and platform status.",
  
  // Tab labels
  ENTITY_SEARCH_LABEL: "Entity Search",
  FINANCIAL_DATA_LABEL: "Financial Data",
  
  // Page titles
  SEARCH_PAGE_TITLE: "Search",
  ABOUT_US_TITLE: "Welcome to Ethics VC",
  // Other messages
  PAGE_DISCLAIMER: "Partial dataset — additional data and details coming soon",

} as const;